import { requestGet } from '../utils/request';

const BASE_URL =
  '/api/user-config/v1/external/configs/values-with-reason/config-key/';

/**
 * Get whether the user has access to the specified feature flag
 * @param {String} flagName
 * @param {Number} userId
 * @param {String} email
 * @return {Promise} Response
 */
export function requestFeature(flagName) {
  const fullFlagName = `feature-flag.${flagName}`;
  return requestGet(`${BASE_URL}${fullFlagName}`);
}
